// People ranges must include every group size from 1 through the maximum.
export function peopleBandCoverageError(formData) {
  if (formData.get('people_price_mode') !== 'bands') {
    return null;
  }

  const maximum = parseInt(formData.get('people_per_unit'), 10);
  if (!maximum || maximum < 1) {
    return 'Enter the maximum number of people for people ranges.';
  }

  const intervalIndices = new Set();
  for (const key of formData.keys()) {
    const match = key.match(/^intervals\[(\d+)\]\[bands\]/);
    if (match) {
      intervalIndices.add(match[1]);
    }
  }

  const covered = `People ranges must include everyone from 1 to ${maximum}.`;
  if (intervalIndices.size === 0) {
    return covered;
  }

  for (const index of intervalIndices) {
    const bands = [];
    for (let bandIndex = 0; bandIndex < 50; bandIndex += 1) {
      const fromValue = formData.get(
        `intervals[${index}][bands][${bandIndex}][from]`,
      );
      const toValue = formData.get(
        `intervals[${index}][bands][${bandIndex}][to]`,
      );
      if (fromValue === null && toValue === null) {
        break;
      }
      const start = parseInt(fromValue, 10);
      const end = parseInt(toValue, 10);
      if (!start || !end || start < 1 || end < start) {
        return 'Each people range needs a start and an end, and the end must be at least the start.';
      }
      bands.push({ start, end });
    }

    bands.sort((left, right) => left.start - right.start);
    if (!bands.length || bands[0].start !== 1) {
      return `${covered} The first range must start at 1.`;
    }
    for (let bandIndex = 1; bandIndex < bands.length; bandIndex += 1) {
      if (bands[bandIndex].start !== bands[bandIndex - 1].end + 1) {
        return `${covered} Ranges cannot leave a gap or overlap.`;
      }
    }
    if (bands[bands.length - 1].end !== maximum) {
      return `${covered} The last range must end at ${maximum}.`;
    }
  }

  return null;
}
